var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext, useState } from "react";
import styled, { css } from "styled-components";
export var ContentContext = createContext({
    lang: "",
    setLang: function () { },
    theme: {},
    contentNodes: {},
    addContentNodes: function () { }
});
export var ContentProvider = function (_a) {
    var children = _a.children, defaultLang = _a.lang, content = _a.content;
    var defaultContentNodes = content.contentNodes, theme = content.theme;
    var _b = useState(defaultLang || "en"), lang = _b[0], setLang = _b[1];
    var _c = useState(defaultContentNodes || {}), contentNodes = _c[0], setContentNodes = _c[1];
    var addContentNodes = function (nodes) {
        setContentNodes(__assign(__assign({}, contentNodes), nodes));
    };
    return (React.createElement(ContentContext.Provider, { value: {
            lang: lang,
            setLang: setLang,
            contentNodes: contentNodes,
            addContentNodes: addContentNodes,
            theme: theme
        } }, children));
};
export function interpolate(string, params) {
    return string.split(/\${|}/gm).reduce(function (prev, curr, i) {
        if (i % 2 === 0) {
            return prev + curr;
        }
        else {
            return prev + params[curr];
        }
    }, "");
}
export var withContent = function (WrappedComponent) { return function (_a) {
    var _b, _c;
    var style = _a.style, contentKey = _a.contentKey, _d = _a.copyParams, copyParams = _d === void 0 ? {} : _d, render = _a.render, children = _a.children, rest = __rest(_a, ["style", "contentKey", "copyParams", "render", "children"]);
    var _e = useContext(ContentContext), contentNodes = _e.contentNodes, theme = _e.theme;
    var copy = useCopy(contentKey, copyParams);
    return (React.createElement(WrappedComponent, __assign({ style: __assign(__assign({}, (_c = (_b = contentNodes) === null || _b === void 0 ? void 0 : _b[contentKey]) === null || _c === void 0 ? void 0 : _c.style), style), theme: theme }, rest),
        React.createElement(React.Fragment, null,
            render ? render(copy) : copy,
            children)));
}; };
export var useContent = function () {
    return useContext(ContentContext);
};
export var useCopy = function (contentKey, copyParams) {
    var _a, _b, _c;
    var _d = useContent(), lang = _d.lang, contentNodes = _d.contentNodes;
    var copy = (_c = (_b = (_a = contentNodes) === null || _a === void 0 ? void 0 : _a[contentKey]) === null || _b === void 0 ? void 0 : _b.copy) === null || _c === void 0 ? void 0 : _c[lang];
    if (!copy) {
        return "MISSING translations for: " + contentKey;
    }
    else if (copyParams) {
        return interpolate(copy, copyParams);
    }
    else {
        return copy;
    }
};
var baseTextStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.centered &&
        "\n    text-align: center;\n  ";
});
export var H1 = withContent(styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), baseTextStyles));
export var H2 = withContent(styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), baseTextStyles));
export var P = withContent(styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), baseTextStyles));
export var Span = withContent(styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), baseTextStyles));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
